import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import "rxjs/Rx";
import "rxjs/add/operator/map";
import { environment } from "../environments/environment";
import {
  AppointmentType,
  HttpResponse,
  PotentialAppointmentListModel,
} from "./widget.model";

@Injectable()
export class WidgetService {
  constructor(private http: HttpClient, private spinner: NgxSpinnerService) {}

  getPotentialAppointments(params: any) {
    this.spinner.show();
    return this.http
      .get<HttpResponse>(
        environment.apiPath + "/api/v1/PotentialAppointments",
        {
          params: params,
        }
      )
      .map((res) => {
        if (res.isSuccess) {
          let value = new Array<PotentialAppointmentListModel>();
          res.payLoad.forEach((elem) =>
            value.push(new PotentialAppointmentListModel(elem))
          );
          return value;
        }
      });
  }

  getAppointmentTypeList(params: any) {
    this.spinner.show();
    return this.http
      .get<HttpResponse>(environment.apiPath + "/api/v1/AppointmentTypes", {
        params: params,
      })
      .map((res) => {
        if (res.isSuccess) {
          let value = new Array<AppointmentType>();
          res.payLoad.forEach((elem) => value.push(new AppointmentType(elem)));
          return value;
        }
      });
  }

  getDoctorList(appointmentTypeUid: string, params: any) {
    this.spinner.show();
    return this.http
      .get<HttpResponse>(
        environment.apiPath + "/api/v1/doctors/" + appointmentTypeUid,
        {
          params: params,
        }
      )
      .map((res) => {
        if (res.isSuccess) {
          return res.payLoad;
        }
      });
  }

  getConsultationHours(params: any) {
    this.spinner.show();
    return this.http
      .get<HttpResponse>(environment.apiPath + "/api/v1/consultationHours", {
        params: params,
      })
      .map((res) => {
        if (res.isSuccess) {
          return res.payLoad;
        }
      });
  }

  bookAppointment(data: any, params: any) {
    return this.http.post<HttpResponse>(
      environment.apiPath + "/api/v1/Appointments",
      data,
      { params: params }
    );
  }

  validatePatient(data: any, params: any) {
    return this.http.post<HttpResponse>(
      environment.apiPath + "/api/v1/Appointments/validate",
      data,
      { params: params }
    );
  }
}



// WEBPACK FOOTER //
// C:/Users/strahinja.aparac/Desktop/git/source/healthcare/v2/app/appointment-widget/src/app/widget.service.ts